// @flow
import Hammer from 'hammerjs';

import React from 'react';
import Mapviewer from './mapviewer';
import visioGlobeApi from '../../../network/api/visioGlobeApi';
import { getCurrentPcId } from '../../../utils/urlUtils';
import { isMobile } from '../../../const';
import BaseMap from './BaseMap';
import type { GeminiRights } from '../../../types/shoppingCenterType';
import { trackPageMap } from '../../../components/GoogleAnalyticsWrapper';
import BaseMapOverlay from './BaseMapOverlay';
import GeminiOverlay from './gemini/GeminiOverlay';
import MappingMode from './mappingMode/MappingMode';

type Props = {
  userGeminiRights: GeminiRights,
  dispatch: () => void,
  isPerf: boolean,
}

type State = {
  mapReady: boolean,
  mappingMode: false,
  preselectedStore: null,
}

class MallMap extends React.Component<Props, State> {
  state: State = {
    mapReady: false,
    mappingMode: false,
    preselectedStore: null,
  };

  mapviewer;
  ref;
  scrollRef;

  componentDidMount() {
    const currentPcId = getCurrentPcId();

    trackPageMap(this.props.userGeminiRights.isAuthorized);

    visioGlobeApi.fetchHashmap(currentPcId)
      .then(response => response.json())
      .then((responseJson: { hashmap: string }) => {
        this.mapviewer = new Mapviewer(
          responseJson.hashmap,
          getCurrentPcId(),
          isMobile,
          false,
          'container',
          () => {
            this.setState({ mapReady: true });
          },
        );
      })
      .then(() => {
        document.dispatchEvent(new Event('mapviewerready'));
      })
      .catch(console.warn);
  }

  changeMappingMode = (preselectedStore?: string) => {
    this.setState(
      {
        mappingMode: !this.state.mappingMode,
        preselectedStore,
      },
      () => {
        this.mapviewer.setMappingMode(this.state.mappingMode);
        this.mapviewer.updateStoreColors();
      },
    );
  }

  getGeminiComponent = () => {
    if (this.state.mappingMode) {
      return (
        <MappingMode
          dispatch={this.props.dispatch}
          changeMappingMode={this.changeMappingMode}
          preselectedStore={this.state.preselectedStore}
          mapviewer={this.mapviewer}
        />
      );
    }
    if (!this.props.userGeminiRights.isAuthorized || !this.props.isPerf) {
      return (
        <div className="raw-map">
          <BaseMapOverlay
            mapviewer={this.mapviewer}
            changeMappingMode={this.changeMappingMode}
            isGeminiUser={this.props.userGeminiRights.isGeminiUser}
            isMappingUser={this.props.userGeminiRights.isMappingUser}
          />
        </div>
      );
    }
    return (
      <GeminiOverlay
        mapviewer={this.mapviewer}
        isMappingUser={this.props.userGeminiRights.isMappingUser}
        isGeminiAdmin={this.props.userGeminiRights.isGeminiAdmin}
        isPulseAuthorized={this.props.userGeminiRights.isPulseAuthorized}
        scrollableElement={this.scrollRef}
        changeMappingMode={this.changeMappingMode}
      />
    );
  };

  render() {
    return (
      <div
        ref={(ref) => {
          this.scrollRef = ref;
        }}
        className="mall-map-container scrollable-content"
      >
        <div className="mapviewer-container">
          <div
            id="vg_mapviewer"
          >
            <div
              ref={(ref) => {
                if (isMobile && !this.ref && ref) {
                  this.ref = ref;
                  const hammertime = new Hammer(ref);
                  hammertime.get('pinch').set({ enable: true });
                }
              }}
              id="container"
              className="visiomap"
            />
            <div id="progress">
              <input
                value="0"
                data-width="150"
                data-readonly="true"
                data-thickness=".2"
                className="knob"
                readOnly="readonly"
              />
            </div>
          </div>
          {
            this.state.mapReady && (
              <BaseMap
                mapviewer={this.mapviewer}
                overlay={this.getGeminiComponent()}
              />
            )
          }
        </div>
      </div>
    );
  }
}

export default MallMap;
